import { useState } from 'react';
// @mui
import { Box, Card, LinearProgress, Stack, Tab, Tabs, Typography } from '@mui/material';
// @types
//
import { ProjectProps } from 'src/@types/project';
import { TextMaxLine } from 'src/components';
import { useResponsive } from 'src/hooks';
import ProjectItem from './ProjectItem';

// ----------------------------------------------------------------------

const tempProjects = [
  { name: 'Stabburveien 14', category: 'Bolig' },
  { name: 'Marken 19', category: 'Næring' },
  { name: 'Starbucks Neumannsgate 25', category: 'Næring' },
  { name: 'Sumo Lagunen', category: 'Næring' },
  { name: 'Leikvang', category: 'Bolig' },
  { name: 'Wergeland Hageby', category: 'Bolig' },
  { name: 'Hjalmar Bratningsvei 2', category: 'Bolig' },
  { name: 'Lynghaug Borettslag', category: 'Bolig' },
  { name: 'Skjoldneshagen', category: 'Bolig' },
  { name: 'Villa Amtmann', category: 'Bolig' },
];

type Props = {
  projects: ProjectProps[];
};

export default function ProjectList({ projects }: Props) {
  const [selected, setSelected] = useState('Alle');

  const getCategories = projects.map((project) => project.projectCategory?.name);

  const categories = ['Alle', 'Pågående', ...Array.from(new Set(getCategories))];

  const filtered = applyFilter(projects, selected);

  const handleChangeCategory = (event: React.SyntheticEvent, newValue: string) => {
    setSelected(newValue);
  };

  return (
    <>
      <Box
        sx={{
          pt: 5,
          pb: { xs: 5, md: 8 },
        }}
      >
        <Tabs
          value={selected}
          scrollButtons="auto"
          variant="scrollable"
          allowScrollButtonsMobile
          onChange={handleChangeCategory}
        >
          {categories.map((category) => (
            <Tab key={category} value={category} label={category} />
          ))}
        </Tabs>
      </Box>

      <Box
        sx={{
          display: 'grid',
          rowGap: { xs: 4, md: 5 },
          columnGap: { xs: 2, md: 2 },
          gridTemplateColumns: {
            xs: 'repeat(2, minmax(0, 1fr))',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
          },
          pb: { xs: 10, md: 15 },
        }}
      >
        {filtered.map((project) => (
          <ProjectItem key={project.slug.current} project={project} />
        ))}
        {tempProjects
          .filter(
            (project) =>
              selected === 'Alle' || (selected !== 'Pågående' && selected == project.category)
          )
          .map((project) => (
            <Card key={project.name}>
              <Box sx={{ overflow: 'hidden' }}>
                <Box
                  bgcolor="grey.800"
                  width={500}
                  height={200}
                  display="float"
                  justifyContent="center"
                  alignItems="center"
                  color="grey.200"
                  p={4}
                >
                  <Typography variant="body3">Innhold kommer</Typography>
                </Box>
              </Box>

              <LinearProgress
                color="inherit"
                variant="determinate"
                sx={{
                  width: 1,
                }}
              />

              <Stack spacing={0.5} sx={{ p: 2.5 }}>
                <Typography variant="body3" sx={{ color: 'text.secondary' }}>
                  {project.category}
                </Typography>

                <TextMaxLine variant="h6">{project.name}</TextMaxLine>
              </Stack>
            </Card>
          ))}
      </Box>

      {/* <Pagination
        count={10}
        color="primary"
        size="large"
        sx={{
          pt: 10,
          pb: { xs: 10, md: 15 },
          '& .MuiPagination-ul': {
            justifyContent: 'center',
          },
        }}
      /> */}
    </>
  );
}

// ----------------------------------------------------------------------

function applyFilter(arr: ProjectProps[], category: string) {
  if (category === 'Pågående') {
    return arr.filter((project) => project.ongoing === true);
  } else if (category !== 'Alle') {
    arr = arr.filter((project) => project.projectCategory?.name === category);
  }
  return arr;
}
